export default "__VITE_ASSET__ByC9Xvj0__"